//const dotenv = require("dotenv")
import dotenv from "dotenv"
dotenv.config()

// if (typeof window !== "undefined") {
//   const mxpUrlParam = new URLSearchParams(window?.location.search);
//   const getUrlParam = (param) => {
//     return mxpUrlParam.get(param) ? mxpUrlParam.get(param).toLowerCase() : null
//   }
// }

let mxpUrlParam

if (typeof window !== "undefined") {
  mxpUrlParam = new URLSearchParams(window.location.search)
} 

const getUrlParam = param => {
  return mxpUrlParam.get(param) ? mxpUrlParam.get(param).toLowerCase() : null
}

const urlRedirects = {
  'plans-and-pricing': {
    ZA: 'https://irender.co.za/buy-sketchup-pro-studio-2021',
    IL: 'https://3dacademy.co.il/product/sketchup-2024-license',
    CN: 'https://sketchupchina.com',
  },
  'resellers': {
    IL: 'https://3dacademy.co.il/product/sketchup-2024-license',
    CN: 'https://www.sketchupchina.com/price/pro',
  },
}

var urlParams = {
  'plans-and-pricing': null,
  'resellers': {
    'utm_education': {
      students: 'https://shop.creationengine.com/collections/sketchup-studio-for-students',
      educators: 'https://shop.creationengine.com/collections/sketchup-studio-for-teachers',
      universities: 'https://shop.creationengine.com/collections/sketchup-studio-for-universities',
    }
  },
}

const fetchInfo = async () => {
  const response = await fetch(`https://pro.ip-api.com/json/?key=${process.env.GATSBY_IP_API_KEY}`)
  if (response.status !== 200) {
    throw new Error("cannot fetch data")
  }
  let data = await response.json()
  return data
}

let newLocation = {}
let formatUrlToMatch = (x) => x.replace(/-/g, "")


export const redirectPageGeneral = (siteName, pathToMatch, currentSlug, paramToMatch ) => {
  // console.log("slug", currentSlug)
  if (siteName !== process.env.GATSBY_SITE_IDENTIFIER) {return}
  if (pathToMatch !== currentSlug) {return}
  fetchInfo().then(data => {  
    // console.log(data)    
    const tempID = formatUrlToMatch(pathToMatch)
    newLocation.urlTo = urlRedirects[pathToMatch] ? urlRedirects[pathToMatch][data.countryCode] : null

    if (paramToMatch){      
      if (urlParams[pathToMatch] && urlParams[pathToMatch][paramToMatch]) {
        const currentUrlParams = getUrlParam(paramToMatch)
        if (currentUrlParams && urlParams[pathToMatch][paramToMatch][currentUrlParams]) {
          newLocation.urlTo = urlParams[pathToMatch][paramToMatch][currentUrlParams]
          // window.location.replace(newLocation.urlTo)
          // return
        }
      }   
    }
    // console.log("newLocation.urlTo", newLocation.urlTo)
    if (newLocation.urlTo) {
      window.location.replace(newLocation.urlTo)
    }
  })
}






